document.addEventListener('DOMContentLoaded', function() {

    // ======= DEMO IDs - Replace these with your actual product & variant IDs =======
    const PRODUCT_ID = 8258029420725; // Replace with your product ID
    const ALL_VARIANTS = [51293403513013, 51293403545781, 51293403578549, 51293403611317, 45499256668341];
   

    // Function to check cart and apply offer
    function applyBundleOffer() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Filter items for your product
            let productItems = cart.items.filter(item => item.product_id === PRODUCT_ID);

            // Limit quantity to 1 per variant
            productItems.forEach(item => {
                if(item.quantity > 1){
                    fetch(`/cart/change.js`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({id: item.key, quantity: 1})
                    });
                }
            });

            // Check how many unique variations are in cart
            let uniqueVariantIds = productItems.map(item => item.variant_id);

            // If 4 unique variations are in cart, add remaining 4 for free
            if(uniqueVariantIds.length === 2){
                let remainingVariants = ALL_VARIANTS.filter(v => !uniqueVariantIds.includes(v));

                remainingVariants.forEach(variantId => {
                    // Check if variant is already in cart
                    if(!uniqueVariantIds.includes(variantId)){
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({
                                id: variantId,
                                quantity: 1,
                                properties: {"_free": "true"} // optional property to mark as free
                            })
                        })
                        //.then(()=> console.log(`Added free variant ${variantId}`));
                    }
                });
            }
        });
    }

    // Run on page load
    applyBundleOffer();

    // Optional: run whenever cart is updated
    document.addEventListener('cart:updated', applyBundleOffer);

});








document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.deferred-media__poster-button').forEach(button => {
    button.addEventListener('click', function handleInitialClick() {
      const container = button.closest('deferred-media');
      if (!container) return;

      // Wait for Shopify to inject the actual video
      const checkForVideo = setInterval(() => {
        const video = container.querySelector('video');
        const toggleButton = container.querySelector('[ref="toggleMediaButton"]');

        if (video && toggleButton) {
          clearInterval(checkForVideo);

          // Unmute and play video
          video.muted = false;
          video.play().catch(() => {});

          // Set up toggle functionality
          setupToggleButton(container, video, toggleButton);
        }
      }, 100);

      // Prevent this from running twice
      button.removeEventListener('click', handleInitialClick);
    });
  });

  function setupToggleButton(container, video, toggleButton) {
    // Clone toggle button to clear default Shopify listeners
    const newToggleButton = toggleButton.cloneNode(true);
    toggleButton.parentNode.replaceChild(newToggleButton, toggleButton);

    // Set initial state
    updateIcons(newToggleButton, video);

    // Add click to toggle button
    newToggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (video.paused) {
        video.muted = false;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }, true);

    // Add click to video area itself (toggle play/pause)
    video.addEventListener('click', function() {
      if (video.paused) {
        video.muted = false;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    // Keep icons synced
    video.addEventListener('play', () => updateIcons(newToggleButton, video));
    video.addEventListener('pause', () => updateIcons(newToggleButton, video));

    // Double-check icon sync after Shopify animation
    setTimeout(() => updateIcons(newToggleButton, video), 500);
  }

  function updateIcons(button, video) {
    const playIcon = button.querySelector('.icon-play');
    const pauseIcon = button.querySelector('.icon-pause');
    if (!playIcon || !pauseIcon) return;

    if (video.paused) {
      playIcon.classList.remove('hidden');
      pauseIcon.classList.add('hidden');
    } else {
      playIcon.classList.add('hidden');
      pauseIcon.classList.remove('hidden');
    }
  }
});













/**** Cart Drawer *****/
function formatMoney(cents) {
  return '₹' + (cents / 100).toFixed(2);
}

(async function() {

  const container = await new Promise((resolve) => {
    const interval = setInterval(() => {
      const el = document.getElementById('cart-upsell');
      if (el) { clearInterval(interval); resolve(el); }
    }, 100);
    setTimeout(() => { clearInterval(interval); resolve(null); }, 10000);
  });

  if (!container) return;

  const cart = await fetch('/cart.js').then(r => r.json());
  if (cart.items.length === 0) return;

  const shown = new Set();
  const products = [];

  for (const item of cart.items) {
    const res = await fetch(
      `/recommendations/products.json?product_id=${item.product_id}&limit=4&intent=complementary`
    );
    const data = await res.json();
    if (!data.products || data.products.length === 0) continue;

    data.products.forEach(product => {
      if (shown.has(product.id)) return;
      shown.add(product.id);
      products.push(product);
    });
  }

  if (products.length === 0) return;

  function getFirstAvailableVariant(product) {
    return product.variants.find(v => v.available) || null;
  }

  function getOptionName(option) {
    if (option && typeof option === 'object' && option.name) return option.name;
    return String(option);
  }

  function hasMultipleOptions(product) {
    const firstName = getOptionName(product.options[0]);
    return !(product.options.length === 1 && firstName === 'Title');
  }

  function renderVariantSelector(product, defaultVariant) {
    if (!hasMultipleOptions(product)) return '';
    const allVariants = product.variants;
    if (allVariants.length === 0) return '';

    if (product.options.length === 1) {
      const optionName = getOptionName(product.options[0]);
      const optionNameLower = optionName.toLowerCase();
      const isColor = optionNameLower.includes('color') || optionNameLower.includes('colour');
      const activeValue = defaultVariant ? defaultVariant.option1 : '';

      if (isColor) {
        return `
          <div class="upsell-option-row" style="width:100%; padding-top:8px;">
            <span class="upsell-option-label">${optionName}</span>
            <span class="upsell-option-value">${activeValue}</span>
          </div>
          <div class="upsell-swatches">
            ${allVariants.map(v => {
              const isAvailable = v.available;
              const isActive = defaultVariant && v.id === defaultVariant.id;
              const swatchImg = (v.featured_image && v.featured_image.src)
                ? v.featured_image.src + '&width=40'
                : product.featured_image + '&width=40';
              return `
                <button
                  class="upsell-swatch ${isActive ? 'active' : ''} ${!isAvailable ? 'sold-out' : ''}"
                  data-variant-id="${v.id}"
                  data-variant-price="${v.price}"
                  data-available="${isAvailable}"
                  data-option-value="${v.option1}"
                  aria-label="${v.option1}${!isAvailable ? ' (Sold out)' : ''}"
                  title="${v.option1}${!isAvailable ? ' (Sold out)' : ''}"
                  style="--swatch-img: url('${swatchImg}')"
                >
                  ${!isAvailable ? `
                    <svg class="upsell-swatch-cross" viewBox="0 0 100 46" preserveAspectRatio="xMidYMid slice">
                      <line x1="100" y1="0" x2="0" y2="46" vector-effect="non-scaling-stroke"></line>
                    </svg>` : ''}
                </button>
              `;
            }).join('')}
          </div>
        `;
      }

      // Non-color single option → pills with label
      return `
        <div class="upsell-option-row" style="width:100%; padding-top:8px;">
          <span class="upsell-option-label">${optionName}</span>
          <span class="upsell-option-value">${activeValue}</span>
        </div>
        <div class="upsell-variant-pills">
          ${allVariants.map(v => {
            const isActive = defaultVariant && v.id === defaultVariant.id;
            return `
              <button
                class="upsell-pill ${isActive ? 'active' : ''} ${!v.available ? 'sold-out' : ''}"
                data-variant-id="${v.id}"
                data-variant-price="${v.price}"
                data-available="${v.available}"
                data-option-value="${v.option1}"
                title="${v.option1}${!v.available ? ' (Sold out)' : ''}"
              >${v.option1}</button>
            `;
          }).join('')}
        </div>
      `;
    }

    // Multi-option → dropdown
    return `
      <select class="upsell-variant-select" data-product-id="${product.id}">
        ${product.variants.filter(v => v.available).map(v => `
          <option value="${v.id}" data-price="${v.price}">${v.title} — ${formatMoney(v.price)}</option>
        `).join('')}
      </select>
    `;
  }

  container.innerHTML = `
    <style>
      #cart-upsell { font-family: inherit; padding: 12px 0; }

      .upsell-header {
        display: flex; align-items: center; justify-content: space-between;
        padding: 0 16px 10px;
      }
      .upsell-header h3 { font-size: 14px; font-weight: 600; margin: 0; color: #1a1a1a; }

      .upsell-dots { display: flex; gap: 5px; align-items: center; }
      .upsell-dot {
        width: 8px; height: 8px; border-radius: 50%;
        background: #ddd; cursor: pointer; transition: background 0.2s;
      }
      .upsell-dot.active { background: #1a1a1a; }

      .upsell-track-wrapper { overflow: hidden; margin: 0 16px; }
      .upsell-track {
        display: flex; gap: 12px;
        transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: grab; user-select: none;
      }

      .cart-upsell-item {
        flex: 0 0 100%; display: flex; align-items: center; gap: 12px;
        background: #fff; border: 1px solid #e8e8e8; border-radius: 10px;
        padding: 10px; box-sizing: border-box; flex-wrap: wrap;
      }

      .upsell-img-link { flex-shrink: 0; display: block; }
      .upsell-img-link img {
        width: 64px; height: 64px; object-fit: cover;
        border-radius: 6px; pointer-events: none; display: block;
      }

      .upsell-info { flex: 1; min-width: 0; }
      .upsell-title-link { text-decoration: none; color: inherit; display: block; }
      .upsell-title-link:hover h4 { text-decoration: underline; }
      .upsell-info h4 {
        font-size: 13px; font-weight: 600; margin: 0 0 4px; color: #1a1a1a;
        line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      }
      .upsell-price { font-size: 13px; font-weight: 500; color: #1a1a1a; }

      .upsell-add {
        flex-shrink: 0; background: #1a1a1a; color: #fff; border: none;
        border-radius: 6px; padding: 8px 16px; font-size: 13px;
        font-weight: 600; cursor: pointer; transition: background 0.2s;
      }
      .upsell-add:hover { background: #333; }
      .upsell-add:disabled { background: #ccc; cursor: not-allowed; }

      /* Option label row — "Color  Blue_Pop" */
      .upsell-option-row {
        display: flex; align-items: center; gap: 6px;
        font-size: 12px; line-height: 1;
      }
      .upsell-option-label {
        font-weight: 600; color: #1a1a1a;
      }
      .upsell-option-value {
        font-weight: 400; color: #555;
      }

      /* Swatches */
      .upsell-swatches {
        display: flex; flex-wrap: wrap; gap: 6px;
        width: 100%; padding-top: 6px;
      }
      .upsell-swatch {
        position: relative;
        width: 28px; height: 28px; border-radius: 50%;
        border: 2px solid transparent;
        padding: 0; cursor: pointer;
        background-image: var(--swatch-img);
        background-size: cover; background-position: center;
        overflow: hidden; transition: border-color 0.15s;
        flex-shrink: 0;
      }
      .upsell-swatch.active {
        border-color: #1a1a1a;
        box-shadow: 0 0 0 1px #1a1a1a;
      }
      .upsell-swatch.sold-out { opacity: 0.5; cursor: not-allowed; }
      .upsell-swatch-cross {
        position: absolute; inset: 0;
        width: 100%; height: 100%;
        stroke: #fff; stroke-width: 2;
        pointer-events: none;
      }

      /* Pills */
      .upsell-variant-pills {
        display: flex; flex-wrap: wrap; gap: 6px;
        width: 100%; padding-top: 6px;
      }
      .upsell-pill {
        font-size: 11px; font-weight: 500; padding: 4px 10px;
        border: 1px solid #ddd; border-radius: 20px;
        background: #fff; color: #1a1a1a; cursor: pointer;
        transition: all 0.15s;
      }
      .upsell-pill.active { background: #1a1a1a; color: #fff; border-color: #1a1a1a; }
      .upsell-pill.sold-out {
        opacity: 0.45; text-decoration: line-through; cursor: not-allowed;
      }

      /* Dropdown */
      .upsell-variant-select {
        width: 100%; margin-top: 8px; padding: 6px 8px;
        font-size: 12px; border: 1px solid #ddd; border-radius: 6px;
        background: #fff; color: #1a1a1a; cursor: pointer;
      }
    </style>

    <div class="upsell-header">
      <h3>You might also like</h3>
      <div class="upsell-dots">
        ${products.map((_, i) => `
          <div class="upsell-dot ${i === 0 ? 'active' : ''}" data-index="${i}"></div>
        `).join('')}
      </div>
    </div>

    <div class="upsell-track-wrapper">
      <div class="upsell-track">
        ${products.map(product => {
          const variant = getFirstAvailableVariant(product);
          const soldOut = !variant;
          const variantId = variant ? variant.id : '';
          const price = variant ? variant.price : product.variants[0].price;
          return `
            <div class="cart-upsell-item" data-product-id="${product.id}">
              <a href="/products/${product.handle}" class="upsell-img-link">
                <img src="${product.featured_image}" alt="${product.title}" />
              </a>
              <div class="upsell-info">
                <a href="/products/${product.handle}" class="upsell-title-link">
                  <h4>${product.title}</h4>
                </a>
                <span class="upsell-price">${formatMoney(price)}</span>
              </div>
              <button
                class="upsell-add"
                data-id="${variantId}"
                ${soldOut ? 'disabled' : ''}
              >${soldOut ? 'Sold out' : 'Add'}</button>
              ${renderVariantSelector(product, variant)}
            </div>
          `;
        }).join('')}
      </div>
    </div>
  `;

  // --- Swatch & Pill clicks ---
  document.addEventListener('click', function handleVariantClick(e) {
    // Swatch
    const swatch = e.target.closest('.upsell-swatch');
    if (swatch) {
      if (swatch.dataset.available === 'false') return;
      const item = swatch.closest('.cart-upsell-item');
      item.querySelectorAll('.upsell-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      const btn = item.querySelector('.upsell-add');
      btn.dataset.id = swatch.dataset.variantId;
      btn.disabled = false;
      btn.textContent = 'Add';
      item.querySelector('.upsell-price').textContent = formatMoney(parseInt(swatch.dataset.variantPrice));
      // Update option value label
      const valueEl = item.querySelector('.upsell-option-value');
      if (valueEl) valueEl.textContent = swatch.dataset.optionValue;
      return;
    }

    // Pill
    const pill = e.target.closest('.upsell-pill');
    if (pill) {
      if (pill.dataset.available === 'false') return;
      const item = pill.closest('.cart-upsell-item');
      item.querySelectorAll('.upsell-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const btn = item.querySelector('.upsell-add');
      btn.dataset.id = pill.dataset.variantId;
      btn.disabled = false;
      btn.textContent = 'Add';
      item.querySelector('.upsell-price').textContent = formatMoney(parseInt(pill.dataset.variantPrice));
      // Update option value label
      const valueEl = item.querySelector('.upsell-option-value');
      if (valueEl) valueEl.textContent = pill.dataset.optionValue;
    }
  });

  // --- Dropdown change ---
  container.addEventListener('change', e => {
    const select = e.target.closest('.upsell-variant-select');
    if (!select) return;
    const item = select.closest('.cart-upsell-item');
    const selected = select.options[select.selectedIndex];
    const btn = item.querySelector('.upsell-add');
    btn.dataset.id = select.value;
    item.querySelector('.upsell-price').textContent = formatMoney(parseInt(selected.dataset.price));
  });

  // --- Carousel ---
  const track = container.querySelector('.upsell-track');
  const dots = container.querySelectorAll('.upsell-dot');
  let current = 0;

  function goTo(index) {
    current = index;
    track.style.transform = `translateX(calc(-${index * 100}% - ${index * 12}px))`;
    dots.forEach((d, i) => d.classList.toggle('active', i === index));
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index)));
  });

  let startX = 0, isDragging = false, dragMoved = false;

  track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
  track.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (diff > 40 && current < products.length - 1) goTo(current + 1);
    if (diff < -40 && current > 0) goTo(current - 1);
  });

  track.addEventListener('mousedown', e => {
    isDragging = true; dragMoved = false; startX = e.clientX;
    track.style.cursor = 'grabbing';
    track.style.transition = 'none';
  });

  window.addEventListener('mousemove', e => {
    if (!isDragging) return;
    const diff = startX - e.clientX;
    if (Math.abs(diff) > 5) dragMoved = true;
    const base = -(current * 100);
    const offset = (diff / track.parentElement.offsetWidth) * -100;
    track.style.transform = `translateX(calc(${base}% + ${offset}% - ${current * 12}px))`;
  });

  window.addEventListener('mouseup', e => {
    if (!isDragging) return;
    isDragging = false;
    track.style.cursor = 'grab';
    track.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    const diff = startX - e.clientX;
    if (diff > 60 && current < products.length - 1) goTo(current + 1);
    else if (diff < -60 && current > 0) goTo(current - 1);
    else goTo(current);
  });

  track.addEventListener('click', e => {
    if (dragMoved) e.stopPropagation();
  }, true);

})();

// --- Add to cart (outside IIFE) ---
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.upsell-add');
  if (!btn || btn.disabled || !btn.dataset.id) return;

  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(btn.dataset.id), quantity: 1 })
  }).then(res => res.json()).then(() => {
    btn.textContent = 'Added ✓';
    setTimeout(() => {
      btn.textContent = 'Add';
      btn.disabled = false;
    }, 1500);
    document.dispatchEvent(new Event('cart:refresh'));
  }).catch(() => {
    btn.textContent = 'Error';
    btn.disabled = false;
  });
});




/***** Restrict FreeBie quantity in cart ******/

document.addEventListener("DOMContentLoaded", function () {

  const TARGET_PRODUCT_IDS = [
    "10418986549429",
    "10418988974261"
  ];

  function lockFreeGiftDrawer() {

    TARGET_PRODUCT_IDS.forEach(function(id) {

      document.querySelectorAll('[data-product-id="' + id + '"]').forEach(function(item) {

        // Hide quantity (drawer)
        let qtyBox = item.querySelector('.AOV-CartDrawer-ItemQuantity');
        if (qtyBox) qtyBox.style.display = "none";

        // Hide remove button (drawer)
        let removeBtn = item.querySelector('.AOV-CartDrawer-ItemRemove');
        if (removeBtn) removeBtn.style.display = "none";

        // Disable all interactions
        item.style.pointerEvents = "none";

      });

    });
  }

  function lockFreeGiftCartPage() {

    document.querySelectorAll('.cart-items__table-row').forEach(function(row) {

      let productId = row.querySelector('[data-product_id]')?.getAttribute('data-product_id');

      if (TARGET_PRODUCT_IDS.includes(productId)) {

        // Hide quantity
        let qty = row.querySelector('quantity-selector-component');
        if (qty) qty.style.display = "none";

        // Hide remove button
        let removeBtn = row.querySelector('.cart-items__remove');
        if (removeBtn) removeBtn.style.display = "none";

        // Disable image link
        row.querySelectorAll('.cart-items__media-container').forEach(el => {
          el.removeAttribute("href");
          el.style.pointerEvents = "none";
        });

        // Disable title link
        row.querySelectorAll('.cart-items__title').forEach(el => {
          el.removeAttribute("href");
          el.style.pointerEvents = "none";
        });

        // Block all clicks
        row.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }, true);

      }

    });
  }

  // GLOBAL click block (for drawer)
  document.addEventListener("click", function(e) {

    const item = e.target.closest('[data-product-id]');
    if (!item) return;

    const productId = item.getAttribute("data-product-id");

    if (TARGET_PRODUCT_IDS.includes(productId)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }

  }, true);

  function init() {
    lockFreeGiftDrawer();
    lockFreeGiftCartPage();
  }

  init();

  // Re-run for AJAX updates
  const observer = new MutationObserver(init);
  observer.observe(document.body, { childList: true, subtree: true });

});





// document.addEventListener('click', function (e) {
//   const radio = e.target.closest('input[type="radio"][name^="Color-"]');
//   if (!radio) return;

//   const selectedAlt = radio.getAttribute('aria-label'); // e.g. "Golden Wheat 7.1"
//   const productId = radio.name.replace('Color-', '').replace('-swatch', '');
//   const gallery = document.querySelector(`.card-gallery[data-product-id="${productId}"]`);
//   if (!gallery) return;

//   const slides = gallery.querySelectorAll('slideshow-slide');

//   slides.forEach(slide => {
//     const img = slide.querySelector('img');
//     if (!img) return;

//     const imgAlt = img.getAttribute('alt');

//     if (imgAlt === selectedAlt || imgAlt === 'ALL') {
//       slide.removeAttribute('hidden');
//       slide.setAttribute('aria-hidden', 'false');
//     } else {
//       slide.setAttribute('hidden', '');
//       slide.setAttribute('aria-hidden', 'true');
//     }
//   });

//   // Scroll slideshow back to first visible slide
//   const scroller = gallery.querySelector('slideshow-slides');
//   const firstVisible = gallery.querySelector('slideshow-slide:not([hidden])');
//   if (scroller && firstVisible) {
//     scroller.scrollTo({ left: firstVisible.offsetLeft, behavior: 'smooth' });
//   }
// });

// Run on page load for each product card gallery
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.card-gallery[data-product-id]').forEach(gallery => {
//     const productId = gallery.dataset.productId;

//     // Find the checked radio for this product
//     const checkedRadio = document.querySelector(
//       `input[type="radio"][name="Color-${productId}-swatch"]:checked`
//     );

//     if (!checkedRadio) return;

//     const selectedAlt = checkedRadio.getAttribute('aria-label');
//     const slides = gallery.querySelectorAll('slideshow-slide');

//     slides.forEach(slide => {
//       const img = slide.querySelector('img');
//       if (!img) return;

//       const imgAlt = img.getAttribute('alt');

//       if (imgAlt === selectedAlt || imgAlt === 'ALL') {
//         slide.removeAttribute('hidden');
//         slide.setAttribute('aria-hidden', 'false');
//       } else {
//         slide.setAttribute('hidden', '');
//         slide.setAttribute('aria-hidden', 'true');
//       }
//     });

//     // Scroll to first visible slide
//     const scroller = gallery.querySelector('slideshow-slides');
//     const firstVisible = gallery.querySelector('slideshow-slide:not([hidden])');
//     if (scroller && firstVisible) {
//       scroller.scrollTo({ left: firstVisible.offsetLeft, behavior: 'instant' });
//     }
//   });
// });







// document.addEventListener('click', function (e) {
//   const radio = e.target.closest('input[type="radio"][name^="Color-"]');
//   if (!radio) return;

//   const selectedAlt = radio.getAttribute('aria-label');
//   const variantId = radio.dataset.variantId; // each radio has data-variant-id
//   const productId = radio.name.replace('Color-', '').replace('-swatch', '');
//   const gallery = document.querySelector(`.card-gallery[data-product-id="${productId}"]`);
//   if (!gallery) return;

  // ✅ Update ALL variant ID hidden inputs for this product
  // document.querySelectorAll(
  //   `input[ref="variantId"], input[name="id"]`
  // ).forEach(input => {
  //   const form = input.closest('form');
  //   if (!form) return;
  //   const productInput = form.querySelector('input[name="product-id"]');
  //   if (productInput && productInput.value === productId) {
  //     input.value = variantId;
  //   }
  // });

  // ✅ Update add-to-cart media preview attribute too
  // document.querySelectorAll(
  //   `add-to-cart-component[data-product-variant-media]`
  // ).forEach(atc => {
  //   const form = atc.closest('form');
  //   if (!form) return;
  //   const productInput = form.querySelector('input[name="product-id"]');
  //   if (productInput && productInput.value === productId) {
  //     const img = radio.closest('label')?.querySelector('.swatch');
  //     if (img) {
  //       const bg = img.style.getPropertyValue('--swatch-background');
  //       atc.setAttribute('data-product-variant-media', bg);
  //     }
  //   }
  // });

  // ... rest of your gallery filter code (slides show/hide)
//   const slides = gallery.querySelectorAll('slideshow-slide');
//   slides.forEach(slide => {
//     const img = slide.querySelector('img');
//     if (!img) return;
//     const imgAlt = img.getAttribute('alt');
//     if (imgAlt === selectedAlt || imgAlt === 'ALL') {
//       slide.removeAttribute('hidden');
//       slide.setAttribute('aria-hidden', 'false');
//     } else {
//       slide.setAttribute('hidden', '');
//       slide.setAttribute('aria-hidden', 'true');
//     }
//   });

//   const scroller = gallery.querySelector('slideshow-slides');
//   const firstVisible = gallery.querySelector('slideshow-slide:not([hidden])');
//   if (scroller && firstVisible) {
//     scroller.scrollTo({ left: firstVisible.offsetLeft, behavior: 'smooth' });
//   }
// });




(function () {

  const selectedState = new WeakMap();

  function applyFilter(gallery, alt, variantId) {
    const slides = gallery.querySelectorAll('slideshow-slide');
    slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (!img) return;
      const imgAlt = img.getAttribute('alt');
      const match = imgAlt === alt || imgAlt === 'ALL';
      if (match) {
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.setAttribute('hidden', '');
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    const scroller = gallery.querySelector('slideshow-slides');
    const firstVisible = gallery.querySelector('slideshow-slide:not([hidden])');
    if (scroller && firstVisible) {
      scroller.scrollTo({ left: firstVisible.offsetLeft, behavior: 'instant' });
    }

    if (variantId) {
      const productCard = gallery.closest('product-card');
      if (productCard) {
        productCard.querySelectorAll('input[ref="variantId"]').forEach(i => {
          i.value = variantId;
        });
      }
    }

    const productCard = gallery.closest('product-card');
    if (productCard) {
      selectedState.set(productCard, { alt, variantId });
    }
  }

  function patchCard(card) {
    // Already patched
    if (card._variantPatched) return;
    card._variantPatched = true;

    // Override resetVariant to restore our selected state instead
    const originalReset = card.resetVariant;
    card.resetVariant = function (...args) {
      const state = selectedState.get(card);
      if (!state) {
        // No state saved yet, let original run
        return originalReset.apply(this, args);
      }
      // Cancel any pending debounced reset
      if (originalReset.cancel) originalReset.cancel();

      // Restore our selected filter
      const gallery = card.querySelector('.card-gallery');
      if (gallery) applyFilter(gallery, state.alt, state.variantId);
    };

    // Also patch cancel so previewVariant's cancel() still works
    card.resetVariant.cancel = function () {
      if (originalReset.cancel) originalReset.cancel();
    };
  }

  function patchAllCards() {
    document.querySelectorAll('product-card').forEach(patchCard);
  }

  function initGalleries() {
    patchAllCards();

    document.querySelectorAll('.card-gallery[data-product-id]').forEach(gallery => {
      const productId = gallery.dataset.productId;
      const checkedRadio = document.querySelector(
        `input[type="radio"][name="Color-${productId}-swatch"]:checked`
      );
      if (!checkedRadio) return;

      applyFilter(
        gallery,
        checkedRadio.getAttribute('aria-label'),
        checkedRadio.dataset.variantId
      );
    });
  }

  // Swatch change
  document.addEventListener('change', function (e) {
    const radio = e.target.closest('input[type="radio"][name^="Color-"]');
    if (!radio) return;

    const productId = radio.name.replace('Color-', '').replace('-swatch', '');
    const gallery = document.querySelector(`.card-gallery[data-product-id="${productId}"]`);
    if (!gallery) return;

    applyFilter(
      gallery,
      radio.getAttribute('aria-label'),
      radio.dataset.variantId
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  } else {
    initGalleries();
  }

})();